import React, { FC } from 'react';
import i18next from 'i18next';
import { User } from '../../../../models/User';
import { EventData } from '../../../../models/EventData';
import map from '../../../../assets/img/icons/ic-map.svg';
import { useStyles } from './styles';

i18next.t('AttendeesEventComponent');

interface Props {
    eventData: EventData;
}

const Attendees: FC<Props> = ({ eventData }) => {
    const classes = useStyles();

    const renderAttendee = (key: number, user: User) => {
        const userLocation = user.user_location ? JSON.parse(user.user_location) : {};

        return (
            <div className={classes.listItem} key={key}>
                <img className={classes.avatar} src={user.user_avatar} alt="" />
                <div className={classes.nameAndLocationContainer}>
                    <span className={classes.name}>{user.user_username}</span>
                    {Object.keys(userLocation).length > 0 && (
                        <span className={classes.city}>
                            <img src={map} alt="" />
                            {userLocation.city}
                        </span>
                    )}
                </div>
            </div>
        );
    };

    return eventData.attendees_users?.length > 0 ? (
        <div className={classes.container}>
            <h6 className={classes.title}>
                {eventData.attendees_users.length} {i18next.t('AttendeesEventComponentAttendee')}
                {eventData.attendees_users.length > 1 && 's'}
            </h6>

            {eventData.attendees_users.map((item: User, index: number) => renderAttendee(index, item))}
        </div>
    ) : null;
};

export default Attendees;
